import { render } from "./dns-zone.vue?vue&type=template&id=404a791e&ts=true"
import script from "./dns-zone.vue?vue&type=script&lang=ts"
export * from "./dns-zone.vue?vue&type=script&lang=ts"

import "./dns-zone.vue?vue&type=style&index=0&id=404a791e&lang=scss"

import exportComponent from "/tmp/build_c94111dd/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__